import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { ColorOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfUiModule } from '@df/ui/df-ui.module';
import { VimeoPlayerComponent } from '@df/ui/display/media/vimeo-player.component';
import { YoutubePlayerComponent } from '@df/ui/display/media/youtube-player.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NShopThisLook, ShopThisLookomponent } from 'projects/app-default/src/app/ui/shop-this-look/shop-this-look.component';
import { SwiperModule } from 'swiper/angular';
import { getCmsContentFieldConfig } from '../../../../../cms/components/components.config';
import { ICmsComponentContentData, ICmsContentVariant, ICmsContentVideoProvider } from '../../../../../cms/components/components.interface';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
export interface ICategories extends NShopThisLook.IData {
    cta_copy?: string;
    cta_color?: string;
    link: string;
    image: string;
    position_cta: string;
}
interface IPageComponentCategoriesCarouselData extends NICmsContentComponent.IData, ICmsComponentContentData {
    title: string;
    sub_title?: string;
    categories: ICategories[];
}
let uid = 0;
@ICmsComponent<PageComponentCategoriesCarouselComponent>({
    id: 'categories-carousel',
    name: 'Categories carousel',
    image: 'assets/images/cms/categories-carousel.png',
    tags: ['category', 'discipline', 'carousel'],
    fields: [
        {
            key: 'title',
            title: 'Title',
            type: NICmsContentField.EFieldType.text,
            default: `What's Your Discipline?`,
            required: true
        },
        {
            key: 'sub_title',
            title: 'Sub Title',
            default: 'Products for Horse and Rider',
            type: NICmsContentField.EFieldType.text
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'categories',
            title: 'Categorise',
            itemName: 'Category',
            itemNameField: 'cta_copy',
            fields: [
                {
                    key: 'cta_copy',
                    title: 'CTA Copy',
                    type: NICmsContentField.EFieldType.text
                },
                <NICmsContentField.IChoiceField>{
                    key: 'cta_color',
                    title: 'CTA Color',
                    type: NICmsContentField.EFieldType.choice,
                    options: ColorOptions,
                    previewMode: 'color',
                    required: true
                },
                {
                    key: 'link',
                    title: 'Link',
                    type: NICmsContentField.EFieldType.text,
                    required: true
                },
                ...getCmsContentFieldConfig('image'),
                <NICmsContentField.IChoiceField>{
                    key: 'position_cta',
                    title: 'Position CTA',
                    type: NICmsContentField.EFieldType.choice,
                    options: [
                        { key: 'on_image', title: 'On the image' },
                        { key: 'underneath_image', title: 'Underneath the image' }
                    ],
                    default: 'on_image',
                    required: true
                },
                ...NShopThisLook.fields
            ],
            default: [
                {
                    position_cta: 'underneath_image',
                    cta_color: 'col-b',
                    cta_copy: 'Eventing',
                    link: '/',
                    image: '/cms/media/default.png'
                },
                {
                    position_cta: 'underneath_image',
                    cta_copy: 'Dressage',
                    image: '/cms/media/default.png',
                    cta_color: 'col-b',
                    link: '/'
                },
                {
                    position_cta: 'underneath_image',
                    cta_copy: 'Leisure Riding',
                    cta_color: 'col-b',
                    link: '/',
                    image: '/cms/media/default.png'
                }
            ]
        }
    ]
})
@Component({
    selector: 'page-component-categories-carousel',
    templateUrl: './categories-carousel.html',
    styleUrls: ['categories-carousel.scss'],
    standalone: true,
    imports: [
        CarouselModule,
        DfUiModule,
        HrefComponent,
        ICmsClientModule,
        ImageModule,
        NgClass,
        RouterLink,
        ShellComponent,
        ShopThisLookomponent,
        SizeClassDirective,
        SwiperModule,
        TranslationModule,
        VimeoPlayerComponent,
        YoutubePlayerComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentCategoriesCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component: IPageComponentCategoriesCarouselData;
    contentVariant = ICmsContentVariant;
    contentVideoProvider = ICmsContentVideoProvider;
    protected uid = uid++;
}
